/**
 * Browser-local read cursor for the Conversation workspace
 * (DIGEMP-CONVERSATION-CENTER-FRONTEND-045, composed by DIGEMP-GLOBAL-CONVERSATIONS-FRONTEND-072).
 *
 * The conversation contract has no server-side unread flag, so "new since your last visit" is
 * tracked per browser in localStorage: conversation id -> highest message sequence_no the operator
 * has already seen in this browser. A conversation this browser has no cursor for is NEVER claimed
 * as unread — absence of knowledge is not evidence of activity.
 */
export const READ_STATE_KEY = "prodigy.conversationCenter.read.v1";

export function loadReadState() {
  try {
    const raw = localStorage.getItem(READ_STATE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function maxSequenceNo(messages) {
  let max = 0;
  for (const m of messages || []) {
    if (typeof m?.sequence_no === "number" && m.sequence_no > max) max = m.sequence_no;
  }
  return max;
}

/**
 * Advance the cursors for a batch of conversations in one write. Only ever moves a cursor forward.
 * Returns the resulting state so callers can keep React state in sync with storage.
 */
export function markConversationsRead(entries) {
  const state = loadReadState();
  let changed = false;
  for (const { id, lastSeenSeq } of entries || []) {
    if (!id || typeof lastSeenSeq !== "number" || !Number.isFinite(lastSeenSeq)) continue;
    const current = state[id];
    if (typeof current === "number" && current >= lastSeenSeq) continue;
    state[id] = lastSeenSeq;
    changed = true;
  }
  if (changed) {
    try {
      localStorage.setItem(READ_STATE_KEY, JSON.stringify(state));
    } catch {
      // Storage unavailable (private mode/quota) — read state simply stays unknown; never a crash.
    }
  }
  return state;
}
